// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.money-guarantee {
  padding: 40px 24px 0;
}

.money-guarantee .inner {
  border-radius: 16px;
  border: 1px solid var(--orange);
  padding:  24px 15px;
}

.money-guarantee .title {
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
  line-height: 28.8px;
  text-align: center;
}
.money-guarantee .text-block {
  margin-top: 16px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
}

.money-guarantee .image {
  margin-top: 12px;
}

.money-guarantee .text-block > a {
  color: var(--orange);
}

.money-guarantee .image {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.money-guarantee.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".money-guarantee {\n  padding: 40px 24px 0;\n}\n\n.money-guarantee .inner {\n  border-radius: 16px;\n  border: 1px solid var(--orange);\n  padding:  24px 15px;\n}\n\n.money-guarantee .title {\n  margin-bottom: 10px;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 28.8px;\n  text-align: center;\n}\n.money-guarantee .text-block {\n  margin-top: 16px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: center;\n}\n\n.money-guarantee .image {\n  margin-top: 12px;\n}\n\n.money-guarantee .text-block > a {\n  color: var(--orange);\n}\n\n.money-guarantee .image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
